import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { actions } from 'store/newDocumentStore';
import DocumentLoader from 'routes/Documents/containers/DocumentLoaderContainer';
import DocumentProvider from 'routes/Documents/containers/DocumentProvider';
import ViewStateContainer from 'routes/Documents/containers/ViewStateContainer';

import QualityOfLife from '../components/QualityOfLife';

const QualityOfLifeContainer = ({ edit, create }) => (
  <DocumentLoader names={['qualityoflife', 'eq5d']}>
    <DocumentProvider>
      <ViewStateContainer>
        <QualityOfLife onStartEdit={edit} onCreate={create} />
      </ViewStateContainer>
    </DocumentProvider>
  </DocumentLoader>
);

QualityOfLifeContainer.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
};

export default connect(null, { edit: actions.createCommit, create: actions.createDocumentAndCommit })(
  QualityOfLifeContainer,
);
